<template>
  <a-layout-header class="layout-header">
    <a-icon
      class="trigger"
      :type="collapsed ? 'menu-unfold' : 'menu-fold'"
      @click="handerFoldBtnClick"
    />

    <a-dropdown>
      <div class="user-info-container">
        <a-avatar class="avatar" icon="user" />
        <span class="name">{{ `你好：${name}` }}</span>
      </div>
      <a-menu slot="overlay">
        <a-menu-item>
          <div>
            <a-icon type="user" />
            <span class="user-menu-item">个人中心</span>
          </div>
        </a-menu-item>
        <a-menu-item>
          <div>
            <a-icon type="setting" />
            <span class="user-menu-item">个人设置</span>
          </div>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item @click="handleLogoutBtnClick">
          <div>
            <a-icon type="logout" />
            <span class="user-menu-item">退出登录</span>
          </div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </a-layout-header>
</template>

<script>
export default {
  name: 'Header',

  computed: {
    collapsed() {
      return this.$store.state.layout.collapsed
    },
    name() {
      return this.$store.state.auth.name
    }
  },

  methods: {
    // 点击折叠
    handerFoldBtnClick() {
      this.$store.commit('layout/collapseMenu', !this.collapsed)
    },

    // 点击退出登录
    handleLogoutBtnClick() {
      this.$store.dispatch('auth/logout')
      this.$router.replace('/login')
      localStorage.vuex = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-header {
  display: flex;
  justify-content: space-between;
  padding: 0;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 99;

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #1890ff;
    }
  }

  .user-info-container {
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #1890ff;
    }

    .avatar {
      background-color: #87d068;
    }
    .name {
      padding-right: 24px;
      margin-left: 10px;
    }
  }
}

.user-menu-item {
  margin-left: 10px;
}
</style>
